import { IAgentFromAPI, APICall } from '../../types';
// Remove unused import - UploadFileStatus is not properly typed
// import { UploadFileStatus } from '../../types/index.d';

export enum DataActionTypes {
  GET_AGENTS = '@@data/GET_AGENTS',
  GET_AGENTS_SUCCESS = '@@data/GET_AGENTS_SUCCESS',
  GET_AGENTS_FAILURE = '@@data/GET_AGENTS_FAILURE',
  SET_IS_WS_PAUSED = '@@visa/IS_WS_PAUSED',
  DEBOUNCE_WS_ACTION = '@@visa/DEBOUNCE_WS_ACTION',

  RETRY_API_CALL = '@@visa/RETRY_API_CALL',
  RETRY_API_CALL_SUCCESS = '@@visa/RETRY_API_CALL_SUCCESS',
  RETRY_API_CALL_FAILED = '@@visa/RETRY_API_CALL_FAILED',

  GET_UPLOAD_FILE_URL = '@@visa/GET_UPLOAD_FILE_URL',
  GET_UPLOAD_FILE_URL_SUCCESS = '@@visa/GET_UPLOAD_FILE_URL_SUCCESS',
  GET_UPLOAD_FILE_URL_FAILURE = '@@visa/GET_UPLOAD_FILE_URL_FAILURE',
  UPLOAD_FILE = '@@visa/UPLOAD_FILE',
  UPLOAD_FILE_SUCCESS = '@@visa/UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE = '@@visa/UPLOAD_FILE_FAILURE',
  DELETE_FILE = '@@visa/DELETE_FILE',
  DELETE_FILE_FAILURE = '@@visa/DELETE_FILE_FAILURE',
}

export interface IUploadFile {
  name?: string;
  status: string; // TODO: Fix type - should be UploadFileStatus enum
  index?: number;
  isFileUploading: boolean;
}

export interface IDownloadFile {
  file?: any;
  isFileDownloading: boolean;
}

export interface IDataState {
  readonly isConfigLoaded: boolean;
  readonly isUniConfigLoaded: boolean;
  readonly isStudentConfigLoaded: boolean;
  readonly isDashboardConfigLoaded: boolean;
  readonly isStudentLoaded: boolean;
  readonly isDashboardStudentsLoaded: boolean;
  readonly isDocsLoaded: boolean;
  readonly agentSuggestions: Array<IAgentFromAPI>;
  readonly apiCallsInProgress: APICall[];
  readonly downloadFile: IDownloadFile | null;
  readonly downloadError: string | null;
  readonly isWsPaused: boolean;
  readonly uploadError: string | null;
  readonly uploadFile: IUploadFile | null;
}
